<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-bell me-2"></i>Erinnerungen</h1>
</div>

<p class="text-muted">Zeigt die nächsten Aufgaben sortiert nach Erinnerungsdatum und gruppiert nach Abteilung.</p>

<ng-container *ngFor="let department of departments">

    <h3 class="h4">{{department.name}} ({{department.tasks?.length}})</h3>

    <div class="table-responsive">
        <table *ngIf="department.tasks?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
            <thead>
            <tr>
                <th>#</th>
                <th>Titel</th>
                <th>Status</th>
                <th>Erstellt am</th>
                <th>Kunde</th>
                <th>Kontakt</th>
                <th>Erinnerung</th>
                <th>Fälligkeit</th>
                <th>Abteilung</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let entry of department.tasks" [routerLink]="['/task', entry.id]">
                <td>{{ entry.id }}</td>
                <td>{{ entry.title }}</td>
                <td>
                    <i class="fa-solid fa-circle"
                       [class.text-danger]="entry.status == 'new'"
                       [class.text-warning]="entry.status == 'in_progress'"
                       [class.text-success]="entry.status == 'done'"
                       [class.text-secondary]="entry.status == 'cancelled'"
                    ></i>
                    {{ entry.status | status }}
                </td>
                <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
                <td>
                    {{ entry.customer }}
                    <span class="text-muted" *ngIf="!entry.customer">Nicht gesetzt</span>
                </td>
                <td>
                    {{ entry.contact }}
                    <span class="text-muted" *ngIf="!entry.contact">Nicht gesetzt</span>
                </td>
                <td>
                    {{ entry.reminder_date | date: 'dd.MM.yyyy' }}
                </td>   <td>
                    <i class="fa fa-exclamation-triangle text-danger" *ngIf="entry.due_date_past"></i>
                    {{ entry.due_date | date: 'dd.MM.yyyy' }}
                </td>
                <td>
                    {{ entry.department }}
                    <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</ng-container>
